import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

const defaultBorderRadius = 20;
const accentBorderRadius = theme.spacing.sp01;

export default createUseStyles(
  {
    root: {
      padding: [theme.spacing.sp02, theme.spacing.sp03],
      background: theme.colors.backgroundSubtle01,
      color: theme.colors.textPrimary,
    },
    my: {
      background: 'linear-gradient(292.42deg, #209AD6 0%, #015990 100%);', // TODO: !!! TOKEN !!! CPF-415
      color: theme.colors.textOnColorPrimary,

      '&$top': {
        borderRadius: [
          defaultBorderRadius,
          defaultBorderRadius,
          accentBorderRadius,
          defaultBorderRadius,
        ],
      },
      '&$center': {
        borderRadius: [
          defaultBorderRadius,
          accentBorderRadius,
          accentBorderRadius,
          defaultBorderRadius,
        ],
      },
      '&$bottom': {
        borderRadius: [
          defaultBorderRadius,
          accentBorderRadius,
          defaultBorderRadius,
          defaultBorderRadius,
        ],
      },
    },
    single: {
      borderRadius: defaultBorderRadius,
    },
    top: {
      borderRadius: [
        defaultBorderRadius,
        defaultBorderRadius,
        defaultBorderRadius,
        accentBorderRadius,
      ],
    },
    center: {
      borderRadius: [
        accentBorderRadius,
        defaultBorderRadius,
        defaultBorderRadius,
        accentBorderRadius,
      ],
    },
    bottom: {
      borderRadius: [
        accentBorderRadius,
        defaultBorderRadius,
        defaultBorderRadius,
        defaultBorderRadius,
      ],
    },
  },
  {
    name: 'Bubble',
  },
);
